import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "admin-layout" }

import { useRouter } from 'vue-router'
import { useAuth } from '@/composables/useAuth'
import Swal from 'sweetalert2'


export default /*@__PURE__*/_defineComponent({
  __name: 'adminHeader',
  setup(__props) {
const router = useRouter()
const { isLogin, userInfo } = useAuth()

const handleLogout = async () => {
  const result = await Swal.fire({
    title: '로그아웃 하시겠습니까?',
    text: '확인 시 로그인 페이지로 이동합니다.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: '로그아웃',
    cancelButtonText: '취소',
    reverseButtons: true
  })

  if (result.isConfirmed) {
    // 1. JWT 삭제
    localStorage.removeItem('jwt')

    // 2. 상태 초기화
    isLogin.value = false
    userInfo.value = null

    // 3. 페이지 이동
    await Swal.fire('로그아웃 완료', '', 'success')
    router.push('/login')
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", { class: "header" }, [
      _createElementVNode("div", { class: "header-link" }, [
        _cache[0] || (_cache[0] = _createElementVNode("a", { href: "/" }, "홈페이지", -1)),
        _createElementVNode("button", {
          type: "button",
          class: "btnst",
          onClick: handleLogout
        }, " 로그아웃 ")
      ])
    ])
  ]))
}
}

})